export default "__VITE_ASSET__0f13526c__"